import {
  FRAMEWORK_AGREEMENT_DOCUMENTS,
  FRAMEWORK_AGREEMENT_DOCUMENTS_ERROR,
  FRAMEWORK_AGREEMENT_DOCUMENTS_SUCCESS,
  FRAMEWORK_DOWNLOAD_DOCUMENT,
  FRAMEWORK_DOWNLOAD_DOCUMENT_ERROR,
  FRAMEWORK_DOWNLOAD_DOCUMENT_SUCCESS
} from './FrameworksAgreementSection.actions'

const frameworkAgreementDocumentsStates = {
  downloads: [],
  frameworkAgreements: [],
  loading: false
}

/**
 * The Framework Agreement Section reducer.
 */
const frameworkAgreementSectionReducer = (state = frameworkAgreementDocumentsStates, { payload, type }) => {
  switch (type) {
    case FRAMEWORK_AGREEMENT_DOCUMENTS:
      return {
        ...state,
        loading: true
      }
    case FRAMEWORK_AGREEMENT_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        frameworkAgreements: payload?.frameworkAgreements
      }
    }
    case FRAMEWORK_AGREEMENT_DOCUMENTS_ERROR: {
      return {
        ...state,
        error: state.error,
        loading: false
      }
    }
    case FRAMEWORK_DOWNLOAD_DOCUMENT: {
      return {
        ...state,
        downloads: state.downloads.concat(payload.id)
      }
    }
    case FRAMEWORK_DOWNLOAD_DOCUMENT_ERROR:
    case FRAMEWORK_DOWNLOAD_DOCUMENT_SUCCESS: {
      return { ...state, downloads: state.downloads.filter(id => id !== payload.id) }
    }
    default: {
      return state
    }
  }
}

export default frameworkAgreementSectionReducer
